import axios from "@/api/axiosAuthRequired.js"
import { BASE_URL } from "@/constants/util"
import { getAuthHeaders } from "@/constants/user"
import baseAxios from "axios"
import store from "@/store/index.store"

export const uploadFile = async (uploadUrl, video) => {
  try {
    const CancelToken = baseAxios.CancelToken
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        store.commit("Vod/setProgress", percentCompleted)
      },
      cancelToken: new CancelToken(function executor (c) {
        store.commit("Vod/setCancelFunction", c)
      }),
    }
    await axios.put(uploadUrl, video, config)
  } catch (error) {
    console.error(error)
    store.commit("Vod/setError", error.response.data)
  }
}

export const fetchBootcampCipSubmissions = async (bootcampKey, extId) => {
  try {
    const url = `${BASE_URL}user/bootcamps/${bootcampKey}/clip-submissions/submissions`
    const params = {
      adapter: "contentful",
      ext_id: extId,
    }
    const config = {
      params,
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getBootcampAcceleratedUploadUrlAndAsset = async (
  bootcampKey,
  clipSubmissionGroupKey,
  fileExtension
) => {
  try {
    const url = `${BASE_URL}user/bootcamps/${bootcampKey}/clip-submissions/${clipSubmissionGroupKey}/upload-url`
    const params = {
      file_extension: fileExtension,
    }
    const config = {
      params,
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    store.commit("Vod/setError", error.response.data)
    return null
  }
}

export const submitAssetUrlForBootcamp = async (
  bootcampKey,
  clipSubmissionGroupKey,
  assetUrl
) => {
  try {
    const url = `${BASE_URL}user/bootcamps/${bootcampKey}/clip-submissions/${clipSubmissionGroupKey}/submissions`
    const body = {
      attachment_url: assetUrl,
    }
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    store.commit("Vod/setError", error.response.data)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/store/vod/vod.apis.js